"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrganizations = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const index_1 = require("../index");

const organizations_1 = require("./organizations");

const useOrganizations = () => {
  const jilFetch = index_1.useJilFetch();

  const getOrganizationsByName = options => {
    return organizations_1.getOrganizationsByName(jilFetch, options);
  };

  const getOrganizationsByTokenizedName = options => {
    return organizations_1.getOrganizationsByTokenizedName(jilFetch, options);
  };

  const getOrganizationsByAdminId = options => {
    return organizations_1.getOrganizationsByAdminId(jilFetch, options);
  };

  const getOrganizationsByContractId = options => {
    return organizations_1.getOrganizationsByContractId(jilFetch, options);
  };

  const getOrganizationsByClaimedDomain = options => {
    return organizations_1.getOrganizationsByClaimedDomain(jilFetch, options);
  };

  const getOrganizationsByEccEndUserId = options => {
    return organizations_1.getOrganizationsByEccEndUserId(jilFetch, options);
  };

  const postOrganizationsByAdminEmail = options => {
    return organizations_1.postOrganizationsByAdminEmail(jilFetch, options);
  };

  const getOrganizationsByIMSOrgId = options => {
    return organizations_1.getOrganizationsByIMSOrgId(jilFetch, options);
  };

  const getOrganizationsSummaries = options => {
    return organizations_1.getOrganizationsSummaries(jilFetch, options);
  };

  return {
    getOrganizationsByAdminId,
    getOrganizationsByClaimedDomain,
    getOrganizationsByContractId,
    getOrganizationsByEccEndUserId,
    getOrganizationsByIMSOrgId,
    getOrganizationsByName,
    getOrganizationsByTokenizedName,
    getOrganizationsSummaries,
    postOrganizationsByAdminEmail
  };
};

exports.useOrganizations = useOrganizations;